import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useLocation } from "react-router-dom"

import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerTitle } from "@/components/ds/Drawer"
import ComingSoonRoute from "@/routes/ComingSoonRoute.tsx"

import GlobalHeader from "./components/GlobalHeader"
import Navbar from "./components/Navbar"
import { DashboardHeaderProvider, DashboardHeaderRenderer } from "./components/PostLoginHeaderContext"
import ReportingYearProvider from "./components/ReportingYear/ReportingYearProvider.tsx"

export default function DashboardLayout() {
  const { t } = useTranslation()
  const location = useLocation()
  const [mobileMenuPath, setMobileMenuPath] = useState<string | null>(null)
  const mobileOpen = mobileMenuPath === location.key
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false)

  return (
    <ReportingYearProvider>
      <DashboardHeaderProvider>
        <div className="flex h-full flex-col">
          <GlobalHeader
            isNavbarCollapsed={isNavbarCollapsed}
            mobileOpen={mobileOpen}
            onToggleMobileNavbar={() => setMobileMenuPath(mobileOpen ? null : location.key)}
            onToggleNavbar={() => setIsNavbarCollapsed((old) => !old)}
          />
          <div className="flex min-h-0 flex-1">
            <div className="hidden md:flex">
              <Navbar isNavbarCollapsed={isNavbarCollapsed} />
            </div>
            <Drawer
              direction="left"
              open={mobileOpen}
              onOpenChange={(open) => setMobileMenuPath(open ? location.key : null)}
            >
              <DrawerContent className="max-w-[280px]">
                <div className="flex items-center justify-between p-4">
                  <DrawerTitle>Moogli</DrawerTitle>
                  <DrawerClose aria-label={t("collapseSidebar")} className="rounded p-2">
                    ×
                  </DrawerClose>
                </div>
                <DrawerDescription className="sr-only">{t("expandSidebar")}</DrawerDescription>
                <div
                  className="flex min-h-0 flex-1"
                  onClickCapture={(event) => {
                    if ((event.target as HTMLElement).closest("a")) setMobileMenuPath(null)
                  }}
                >
                  <Navbar isNavbarCollapsed={false} />
                </div>
              </DrawerContent>
            </Drawer>
            <section className="flex min-w-0 grow flex-col overflow-auto bg-neutral-secondBg">
              <ComingSoonRoute>
                <DashboardHeaderRenderer />
                <Outlet />
              </ComingSoonRoute>
            </section>
          </div>
        </div>
      </DashboardHeaderProvider>
    </ReportingYearProvider>
  )
}
